import { render } from "./Vikings.vue?vue&type=template&id=eb28e61e"
import script from "./Vikings.vue?vue&type=script&lang=js"
export * from "./Vikings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__